<template lang="pug">
AppSelect(
  v-model="selected"
  :options="options"
  :select2-options="select2Options"
)
</template>

<script>
export default {
  name: 'ActivitiesClientTypeFilter',
  props: {
    value: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    select2Options: {
      allowClear: true,
      multiple: false,
      width: '100%',
      placeholder: 'All sources',
    },
  }),
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>
